import { useModality } from '../../hooks/use-modality'
import { Eye, Pencil, Trash2 } from 'lucide-react'
import { Link } from 'react-router-dom'

export const ResourceFile = () => {
  const { data, loading, error } = useModality()

  if (loading) return <div className='p-6 text-center'>Loading modalities...</div>
  if (error) return <div className='p-6 text-red-600'>Error: {error}</div>

  return (
    <div className='p-6'>
      {/* Header Section */}
      <div className='flex items-center justify-between mb-6'>
        <h1 className='text-3xl font-bold'>Resource file manager</h1>
        <div className='flex items-center justify-between mb-6'>
          <button type='submit' className='bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 mr-4'>
            Genearte extraction
          </button>
          <Link to='/modalities/new' className='bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800'>
            Add Document +
          </Link>
        </div>
      </div>

      {/* Intro paragraph */}
      <p className='text-gray-600 mb-6 max-w-3xl'>
        A learning modality is the way an individual best takes in, processes, and retains new information. Below is a list of the identified learning
        modalities that are used to evaluate a student’s learning process.
      </p>

      {/* Table */}
      <div className='overflow-x-auto rounded-xl border border-gray-200 shadow-sm'>
        <table className='min-w-full text-left'>
          <thead className='bg-gray-50 text-sm font-semibold text-gray-700'>
            <tr>
              <th className='px-4 py-3'>
                <input type='checkbox' className='h-4 w-4 rounded border-gray-300' />
              </th>
              <th className='px-4 py-3'>File name</th>
              <th className='px-4 py-3'>Document</th>
              <th className='px-4 py-3'>Created by</th>
              <th className='px-4 py-3'>Date Added</th>
              <th className='px-4 py-3 text-center'>Status</th>
              <th className='px-4 py-3 text-center'>Actions</th>
            </tr>
          </thead>
          <tbody className='divide-y divide-gray-200'>
            {data.length > 0 ? (
              data.map((row: any) => (
                <tr key={row.id} className='hover:bg-gray-50'>
                  <td className='px-4 py-3'>
                    <input type='checkbox' className='h-4 w-4 rounded border-gray-300' />
                  </td>
                  <td className='px-4 py-3 font-medium'>
                    <Link to={`/modalities/${row.id}`} className='text-blue-700 hover:underline focus:underline outline-none'>
                      {row.name}
                    </Link>
                  </td>

                  <td className='px-4 py-3 text-gray-700 max-w-md truncate'>{row.description}</td>
                  <td className='px-4 py-3'>{row.createdBy ?? '—'}</td>
                  <td className='px-4 py-3'>
                    {row.created
                      ? new Date(row.created).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric',
                        })
                      : '—'}
                  </td>

                  <td className='px-4 py-3 text-center'>
                    <label className='inline-flex items-center cursor-pointer'>
                      <input type='checkbox' className='sr-only peer' defaultChecked={row.status} />
                      <div
                        className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer
                        peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px]
                        after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5
                        after:transition-all peer-checked:bg-blue-600"
                      />
                    </label>
                  </td>

                  <td className='px-4 py-3 text-center'>
                    <div className='flex items-center justify-center gap-3 text-gray-500'>
                      <Link to={`/modalities/${row.id}`} title='View' className='inline-flex'>
                        <Eye className='w-5 h-5 hover:text-gray-800' />
                      </Link>
                      <Link to={`/modalities/${row.id}/edit`} title='Edit' className='inline-flex'>
                        <Pencil className='w-5 h-5 hover:text-gray-800' />
                      </Link>
                      <button title='Delete'>
                        <Trash2 className='w-5 h-5 hover:text-red-600' />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className='px-4 py-6 text-center text-gray-500'>
                  No modalities found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
